import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

class TariffConstructor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Button: null,
      Popup: null,
      externalStore: null,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const Button = R.path(['beeline', 'pages', 'TariffConstructor'], window);
      const Popup = R.path(['beeline', 'pages', 'TariffConnectPopup'], window);
      const externalStore = R.path(['beeline', 'store'], window);

      if (Button && Popup && externalStore) {
        this.setState({ Button, Popup, externalStore });
        clearInterval(this.interval);
      }
    }, 50);
  }

  render() {
    const {
      isDisabled,
      isConvergent,
      className,
      description,
    } = this.props;
    const { Button, Popup, externalStore } = this.state;

    if (!Button || !Popup || !externalStore) {
      return null;
    }

    const newDescription = isConvergent ? description.mobile : description.desktop;

    return (
      <>
        <div className={cx('button', { disabled: isDisabled }, className)}>
          <Button
            store={externalStore}
            bannerData={{ description: newDescription }}
            authenticated
            tariffConnected
            bannerClassName={cx({ convergentButton: isConvergent })}
            {...this.props}
          />
        </div>
        <Popup store={externalStore} />
      </>
    );
  }
}

TariffConstructor.propTypes = {
  isDisabled: PropTypes.bool,
  description: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
  }),
  isConvergent: PropTypes.bool,
  className: PropTypes.any,
};

export default TariffConstructor;
